import React from 'react'
import { Link } from 'gatsby'

import Layout from '../../components/layout'
import Image from '../images/elfego-gomez.jpg'
import SEO from '../../components/seo'

const IndexPage = () => (
  <Layout>
    <SEO title="Elfego Gomez III" keywords={[]} />
    <div id="main" role="main">
      {' '}
      <div id="content" style={{ display: 'inline-block' }}>
        <h1 className="page-title">Elfego Gomez III</h1>
        <div>
          <p>
            <img
              className="alignleft size-full wp-image-338"
              style={{ float: 'left' }}
              title="elfego-gomez-bio"
              src={Image}
              alt
              width={200}
            />
            Elfego Gomez III is the principal in Gómez &amp; Associates as well
            as an adjunct faculty member with Duke Corporate Education’s –
            Global Learning Resource Network (GLRN) and the Center for Creative
            Leadership (CCL). Gómez &amp; Associates is an international
            consulting and training company dedicated to leadership development
            and education, team alignment and effectiveness, and optimizing
            individual and corporate value. Clients hire Gómez &amp; Associates
            for their creative and audience engaging programs which have
            measurable results, lasting impact, and spur continual learning.
            During his tenure with Duke CE he has worked with clients in Africa,
            South America and North America and at the Center for Creative
            Leadership, he has worked with CCL’s Leadership at the Peak Program
            (LAP) as well as several custom programs.
          </p>
          <p>
            Elfego brings over twenty years of diverse experience and
            perspective from work with executive teams in the Fortune 100,
            supervisors in the U.S. Federal Government, presidents of
            non-profits, leaders in public education and family owned
            businesses. He is a former director with Junior Achievement
            Worldwide where he was responsible for internal consulting, design
            and facilitation of training and development needs for associates in
            over 100 U.S. and International area offices. He also worked for
            Action Learning Associates, an international training and
            development company where he had experience in program design,
            executive coaching and was faculty at numerous corporate leadership
            academies. Additionally, Elfego is a certified practitioner in a
            wide array of assessment tools including the Benchmark 360°,
            Myers-Briggs Type Indicator, the Campbell Leadership Index and
            Situation Leadership, to name just a few.
          </p>
          <p>
            Elfego specializes is in the design and facilitation of initiatives
            to develop the next generation of leaders, supplant team discord
            with high performance and synchronize organizational vision and
            direction. These programs are highly interactive and based upon a
            broad compendium of approaches including business simulations,
            action learning projects and psychometric assessments. His
            consultative services often focus on such themes as leadership team
            alignment, organizational branding and cultural mapping, promoting
            diversity leadership, fostering innovation and breakthrough
            thinking, as well as managing change initiatives.
          </p>
          <p>
            Elfego has degrees from the University of Notre Dame and the
            University of Arizona as has done post-graduate study at the
            Teacher’s College, Columbia University and the Fletcher School of
            International Law and Diplomacy, Tufts University. In his free time
            he runs, skis, cycles and eats dark chocolate.
          </p>
        </div>
      </div>
    </div>
  </Layout>
)

export default IndexPage
